import React, { useState } from 'react';
import { Button } from '@mui/material';

import ViewMessagesModal from './ViewMessagesModal';

const MessageButton = ({ disputeData }) => {
  const [viewMessageDispute, setViewMessageDispute] = useState({});

  const { disputeInfo, lotInfo, bidderInfo } = disputeData || {};
  const { disputeRef = '', openDispute = false, disputeID } = disputeInfo || {};
  const { lotNumber = '', lotTitle = '', lotExt = '' } = lotInfo || {};
  const { firstName = '', lastName = '' } = bidderInfo || {};
  const messageHeading = `${firstName} ${lastName}, Lot ${lotNumber}${lotExt}: ${lotTitle}`;

  return (
    <>
      <Button
        variant="text"
        size="small"
        className="message-button"
        onClick={() =>
          setViewMessageDispute({ disputeRef, messageHeading, openDispute, disputeID })
        }
      >
        View
      </Button>
      {Boolean(Object.keys(viewMessageDispute).length) && (
        <ViewMessagesModal
          viewMessageDispute={viewMessageDispute}
          onClose={() => setViewMessageDispute({})}
        />
      )}
    </>
  );
};

export default MessageButton;
